// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___1x7R4","empty":"styles__empty___nTSnn","attach":"styles__attach___12mb-"};